<template>
<div class="container-fluid">

    <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />


<!-- PRODUCT MASTER  -->
<div v-if="type=='A'">

<div class="row">
<div  class="col">

<check-product ref="checkModal"  @createProduct="insertProduct()" @update="setProduct"  v-bind:items="items" ></check-product>

  <button @click="$emit('back')" class="btn btn-secondary btn-block">      
    <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
      RITORNA AL DOCUMENTO
  </button>

  <div class="card border-info mt-1">
  <h4 class="card-header bg-info border-info">
   
    <div v-if="!product.productId">
      <h4 style="color:black" class="text-center"><strong>REGISTRAZIONE NUOVO PRODOTTO </strong></h4>
    </div>  

    <div v-else>
      <h4 style="color:red" class="text-center"><strong>PRODOTTO ESISTENTE ID [ {{product.productId}} ] </strong> </h4>
    </div>

  </h4>

  <div class="card-body">
    
  
 <div class="btn-toolbar " role="toolbar" aria-label="Toolbar with button groups"> 
  
  <button @click="type='SupplierProducts'" type="button"  data-toggle="tooltip" title="Ricerca prodotto del fornitore." class="btn btn-outline-primary   mr-1 mb-1">
    <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
    RICERCA PRODOTTO
  </button> 

  <div class="btn-group btn-group-lg ml-2 mb-1">    
 
 
 
  <div class="btn-group" role="group">
    
    <button id="btnGroupDrop1" type="button" class="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
      <i class="fas fa-edit mr-2" aria-hidden="true"></i>
      CLASSIFICAZIONE
    </button>

    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
      <a @click="lineModal()" class="dropdown-item" href="#">LINEA</a>
      <a @click="type='C'" class="dropdown-item" href="#">CATEGORIA</a>
      <a  v-if="false" @click="type='D'" class="dropdown-item" href="#">ATTRIBUTI</a>
    </div>
  </div>


  <!--NUOVO PRODOTTO  -->
  <button @click="setNewProduct()" type="button" data-toggle="tooltip" title="Reset anagrafica prodotto." class="btn btn-outline-primary rounded-sm ml-3">
    <i class="fas fa-trash" aria-hidden="true"></i>  
  </button> 

</div>
 </div>
    <form name="productMaster" v-on:submit.prevent="submit()">
      <div  class="card bg-light text-dark">
      <div class="card-body">
      <div class="row">

        <!-- SUPPLIER -->
        <div class="col">
          <div class="form-group">
            <supplier-select v-bind:Id="doc.supplierId" v-bind:isActive="false"></supplier-select>
          </div>
        </div>

        <!-- BRAND -->
        <div class="col">          
          <div class="form-group">
            <supplier-brand-select :key="brandKey"  @update="setBrand" v-bind:_brand="product.brand" v-bind:required="true" v-bind:supplierId="doc.supplierId"></supplier-brand-select>
          </div>
        </div>

        <!-- SKU -->
        <div class="col">
          <div class="form-group">
            <label for="codice"><strong>CODICE PRODOTTO DEL FORNITORE</strong></label>
            <input autocomplete="off" required v-model = "product.sku" type="text" class="form-control bold" placeholder="" id ="sku" name="sku">            
          </div>
        </div>
        <!-- ROW -->
      </div>
      <!-- CARD BODY -->
      </div>
      <!-- CARD -->
      </div>
      
      <div  class="card bg-light text-dark">
      <div class="card-body">
        <div class="row">
        <div class="col">    

          <!-- LINE MODAL -->
          <div class="col-md-4">
            <line-modal @update="refreshLine" v-bind:supplierId="doc.supplierId"></line-modal>  
          </div>

          <div class="form-group">
            
            <!-- LINE -->
            <line-select :key="lineKey"  @update="setLine" v-bind:Id="product.lineId" v-bind:supplierId="doc.supplierId"></line-select>
            
          
                       
            <!--<a @click="lineModal()" href="#"><small>Crea Nuova</small></a>-->

          </div>
        </div>

        <!-- CATEGORY -->
        <div class="col">    
          <div class="form-group">
            <!--<category-select  :key="categoryKey" v-bind:isActive="true"  v-bind:Id="product.categoryId"  v-bind:required="true" @update="setCategoryId"></category-select>-->
            <category-vue-select :key="categoryKey" @input="setCategoryId" v-bind:props="category"></category-vue-select>
          </div>
        </div>

        <!-- DESCRIPTION -->
        <div class="col">    
        <div class="form-group">
          <label for="descrizione">DESCRIZIONE</label>
          <input  v-model="product.description" type="text" class="form-control bold" placeholder="" id ="descrizione">
        </div>
        </div>
        <!-- ROW -->
        </div>
        <div class="row">
        <div class ="col-sm">  
        <div class="form-group">
        <!-- DEPARTMENT -->
        <department-select :key="departmentKey" v-bind:Id="product.departmentId" @update="setDepartment" v-bind:required="true" v-bind:isActive="true" v-bind:type="true"></department-select>
        </div>
            </div>
            <div class ="col-sm">  
              <div class="form-group">
              <!-- SEASON -->
              <season-select :key="seasonKey" @update="setSeason" v-bind:Id="product.seasonId" v-bind:required="true" v-bind:isActive="true" v-bind:type="true"></season-select>
                
              </div>

            </div>
            <div class ="col-sm"> 
            <div class="form-group">
              <!-- YEAR -->
              <year-select :key="yearKey" @update="setYear" v-bind:required="true" v-bind:_year="product.season_year" v-bind:isActive="true"></year-select>   
              </div>      


            </div>
          </div>
          
          <div class="row">

          <div class="col-sm">    
          <div class="form-group">
            <label for="composizione">COMPOSIZIONE</label>
            <input  v-model="product.material" type="text" class="form-control bold" placeholder="" id ="material">
          </div>
          </div>

          <div class="col-sm">    
          <div class="form-group">
            <label for="dimension">DIMENSIONE</label>
            <input  v-model="product.dimension" type="text" class="form-control bold" placeholder="" id ="dimension">
          </div>
          </div>

          <div class="col-sm">    
          <div class="form-group">
            <label for="dimension">MADE IN</label>
            <input  v-model="product.madeIn" type="text" class="form-control bold" placeholder="" id ="madeIn">
          </div>
          </div>
                      
          </div>

           <div v-if="product.productId==0 && 1==0" class="form-check alert alert-warning rounded p-3  float-right">                        
            <input  class="form-check-input" type="checkbox" id="inlineFormCheck" v-model="productAttributes">
            <label class="form-check-label" for="inlineFormCheck">
              <strong>ASSOCIA ATTRIBUTI</strong>
            </label>
            
          </div>

              <div v-if="product.productId == 0" class="d-flex justify-content-end">
                <div class="d-inline-flex alert alert-warning align-items-center p-3 border border-warning rounded">
                  <label class="mb-0 mr-2">
                    ASSOCIA ATTRIBUTI
                  </label>
                  <div class="custom-control custom-switch">
                    <input 
                      type="checkbox" 
                      class="custom-control-input" 
                      id="customSwitch1" 
                      v-model="productAttributes"
                    >
                    <label class="custom-control-label" for="customSwitch1"></label>
                  </div>
                </div>
              </div>

      </div>
      </div>

  

    <button type="submit"  class="btn btn-primary float-right mt-1 mb-1 mr-3">
     
      <i class="fas fa-chevron-circle-right mr-2" aria-hidden="true"></i>      
       <span v-if="product.productId">PROCEDI</span>
       <span v-else>SALVA E PROCEDI</span>
     
    </button> 
           
    </form>
  </div> 
  </div> 
  <!-- COL -->
  </div>

  


  <!-- ROW -->
  </div>
</div>

<div v-else-if="type=='C'">

  <button @click="type='A'" class="btn btn-secondary btn-block mb-1">      
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                    RITORNA A REGISTRAZIONE PRODOTTO
  </button>    
  <category v-bind:document="true"></category>

</div>  



<div v-else-if="type=='E'">

  <button @click="setPromise()" class="btn btn-warning btn-block mt-1">      
                <i style="color:black" class="fas fa-share-square mr-2" aria-hidden="true"></i>
                    PROCEDI
  </button>   

  <gestione-attributi v-bind:productId="product.productId"></gestione-attributi> 
  

</div>  


<div v-else-if="type=='SupplierProducts'" >
  <find-product v-bind:supplierId="doc.supplierId" @update="setProduct"></find-product>
</div>  
  
  
     <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre>{{ uuid }} </pre> 
      
    </div>

  <!-- MAIN DIV -->
  </div>    

</template>
<script>



import api                   from '@/api'
import supplierSelect        from '@/components/common/SupplierSelect.vue' 
import supplierBrandSelect   from '@/components/common/SupplierBrandSelect.vue'

import lineSelect            from '@/components/common/LineSelect.vue'
import seasonSelect          from '@/components/common/SeasonSelect.vue'
import departmentSelect      from '@/components/common/DepartmentSelect.vue'
import yearSelect            from '@/components/common/YearSelect.vue'
import lineModal             from '@/components/common/LineModal.vue'
import findProduct           from '@/components/product/FindProduct.vue'
import category              from '@/components/category/Category.vue'
import checkProduct          from '@/components/product/ModalCheckMatchingProducts.vue'

import categoryVueSelect     from '@/components/common/CategoryVueSelect.vue'
import modalMessage          from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm          from '@/components/modalDialog/ModalConfirm.vue'

import gestioneAttributi     from '@/components/product/GestioneAttributi.vue'



import { mapGetters }        from 'vuex';
import { v4 as uuidv4 }      from 'uuid'


export default { 
  
  

  props : {item : Object,doc : Object},
  components: {supplierSelect,supplierBrandSelect,lineSelect,seasonSelect,departmentSelect,yearSelect,lineModal,findProduct,category,checkProduct,categoryVueSelect,modalMessage,modalConfirm,gestioneAttributi

  },
  
  data () {
      return {


        type            : 'A',  
        product         : {'productId' : 0,'supplierId':0},
        category        : {'Id' : null},
       
        lineKey           : 0,        
        categoryKey       : 100,
        brandKey          : 200,
        departmentKey     : 300,
        seasonKey         : 400,
        yearKey           : 500,
        items             : [],        
        uuid              : '',
        productAttributes : false,
        promise           : true
       
       
        }
    },
    computed: 
    {     
     ...mapGetters(['company']) 
      
    },
          

    directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()}
       
      }
    },

  mounted()  
  {
    

    this.product = this.item
    this.brandKey++
    
    this.category.Id = this.item.categoryId
    this.refreshAll()

  },
  created()
  {
    this.uuid          = uuidv4()
  },
  methods: 
  {
      setPromise()
      {
        this.promise = false
      },
     awaitPromise()
        {
           
            //this.promise = true
            return new Promise(resolve => {
                const unwatch = this.$watch('promise', val => {
                if (!val) {
                    unwatch()
                    resolve()
                }
                })
            })
    },
    



    setNewProduct()
    {

      
      this.product            = {}
      this.product.productId  = 0
      // this.product.supplierId = this.doc.supplierId
      this.product.barcodes   = []
      this.product.counter    = 0 
          
      this.category.Id = null
      
      this.refreshAll()

      
      
      
    },
    refreshAll()
    {
      this.departmentKey++
      this.brandKey++
      this.seasonKey++
      this.categoryKey++
      this.yearKey++
      this.lineKey++
    
    },
    setProduct(product)
    { 
      this.type = 'A'     
      if(product.productId == 0 )
      {
        this.setNewProduct()
      }
      else
      {
        this.product     = product  
        this.category.Id = product.categoryId
        this.refreshAll()

      }

      //this.type = 'A'

    },
    refreshLine()
    {
      $('#lineModal').modal('hide');
      this.lineKey++
    },
    setBrand(brand)
    {
      this.product.brand = brand
    },
    setLine(lineId)
    {      
      this.product.lineId = lineId
    },
    setCategoryId(categoryId)
    {
      this.product.categoryId = categoryId
    },
    
    setDepartment(departmentId)
    {
      this.product.departmentId = departmentId
    },
    setSeason(seasonId,e)
    {
      
      this.product.seasonId = seasonId
      
      if(e.target.options.selectedIndex>-1)
      {
        this.product.season = e.target.options[e.target.options.selectedIndex].text
        
      }

    },
    setYear(year)
    {
      this.product.season_year = year
    },
    lineModal()
    {
      $('#lineModal').on('shown.bs.modal', function (e) {
        $('#inputLine').val('');
        $('#inputLine').trigger('focus');
      })
      $('#lineModal').modal({keyboard: false,backdrop:'static'});
    },

   
    async ControlloProdottiSimili() {

            
              this.$refs.confirmModal.setSpinner(true)
              this.product.supplierId = this.doc.supplierId  
              const payload = {
                sp : 'spCheckingSimilarProducts',
                companyId: this.company.Id,
                ...this.product
              }

              try {
                const res = await api.post(payload)

                  if (res.status !== 200) 
                  {
                    throw new Error(res.data || res)
                  }
                  
                  this.$refs.confirmModal.close()                 
                  return res.data.recordsets

                
              } catch (err) 
              {

                this.$refs.confirmModal.close()
                throw err

              } finally {} 
    },


    async ProdottiMovimento()
    {
      
      
      this.$refs.msgModal.show()                      
      this.$refs.msgModal.setSpinner(true,{'title':'CONTROLLO ESISTENZA PRODOTTO SUL DOCUMENTO ...'})    

      const payload = {
              sp : 'spCheckingMovementProduct',
                    'stockMovementId' : this.doc.stockMovementId,
                    'productId'       : this.product.productId
                    }
      
          try {
                


                const res = await api.post(payload)
                
                this.$refs.msgModal.setSpinner(false)    
                this.$refs.msgModal.close()   
                
                  if (res.status !== 200) 
                  {
                    throw new Error(res.data || res)
                  }
                  this.$refs.msgModal.close()   
                  return res.data.recordsets[0].length == 0
              }       

              catch(err){
                 throw err
              }
    

    },
   

    async submit() 
      {
        
                
         // CONTROLLO ANNO E STAGIONE 
        if(this.product.seasonId != this.doc.seasonId || this.product.season_year != this.doc.season_year)
        {
            let msg = 'L\'ANNO E/O LA STAGIONE ANAGRAFICA DEL PRODOTTO NON COINCIDONO CON QUELLI DELLA COLLEZIONE.'
            msg += '\n\nPROCEDO COMUNQUE   ?'
            const confirmed=  await this.$refs.confirmModal.show(msg
            ,
            { title: '' },1)

            if (!confirmed) return  
            this.$refs.confirmModal.close()
        }




        if(this.product.productId > 0)
        {
         
          try{

              const controllo = await  this.ControlloProdottiDocumento()
              // NON ESISTE NEL DOCUMENTO
              if(controllo)
              {
                  this.$emit('update',this.product)
                      
              }
              else
              {
                  const msg      = 'PRODOTTO GIA\' INSERITO SUL DOCUMENTO .' 
                  await this.$refs.msgModal.show(msg,{},1)            
                  return
                  
              }
              
          }
        
                
          catch(err)
          {     
                await this.$refs.msgModal.show(err.message,{},3)
                return
          }

        }

        else{
 
          try{
              
              this.items = await this.ControlloProdottiSimili()
              if(this.items[0].length > 0)
                {
                  
                     this.$refs.confirmModal.close()                  
                    // MODALE CONTROLLO PRODOTTI SIMILI
                    this.$nextTick(() => {
                        this.$refs.checkModal.show() })
                        return

                }
                

          }
         catch(err)
         {
            this.$refs.msgModal.show(err.message,{},3)
            return
         }
                                     
          const confirmed = await this.$refs.confirmModal.show('SI DESIDERA REGISTRARE IL NUOVO PRODOTTO ?',{'title':'CONFERMA'},1)
          if(!confirmed) return 
        
                this.insertProduct()

          }       
      
        
        
               
        
      },
    
    async ControlloProdottiDocumento()
    {
      try{
        

        const res = await this.ProdottiMovimento()        
        return res
        

      }
      catch(err){
          await this.$refs.msgModal.show(err,{'title':'ATTENZIONE'},3)        
          throw err
      }
    },  
   
  
    async insertProduct()
    {
        
        this.$refs.confirmModal.close()
        this.product.supplierId = this.doc.supplierId
        const uuid              = this.uuid
                
        const companyId         = this.company.Id
        const sp                = 'spCreateProductNewRequestLog'
        const payload           = {...this.product,sp,companyId,uuid

        }
         try {

                this.$refs.msgModal.show()                
                this.$refs.msgModal.setSpinner(true)    

                const res = await api.post(payload)

                  if (res.status !== 200) 
                  {
                    throw new Error(res.data || res)
                  }
                 
     
                this.$refs.msgModal.setSpinner(false)  
                  
                const productId        = res.data.recordsets[0][0].id
                this.product.productId = productId
                this.product.counter   = 1
                this.product.barcodes  = []
                
                this.$refs.msgModal.close()

                if(this.productAttributes)
                {
                  this.type = 'E'
                  await this.awaitPromise()

                }
                this.$emit('update',this.product)        
                
                
                

              } catch (err) {
                
                console.log(err)
               
                this.$refs.msgModal.show(err.message,{},3)
                

              } finally {
                
              }

              
    },
    async updateProduct()
    {
        this.bt_spinner = true
        var create_at  = new Date()   
        
        const item = 
        {
        'supplierId'  : this.doc.supplierId,   
        'sku'         : this.product.sku, 
        'brand'       : this.product.brand,
        'categoryId'  : this.product.categoryId,
        'update_at'   : create_at,
        'departmentId': this.product.departmentId,
        'seasonId'    : this.product.seasonId,
        'season_year' : this.product.season_year,
        'lineId'      : this.product.lineId ? this.product.lineId : 0,
        'description' : this.product.description ? this.product.description : '', 
        'productId'   : this.product.productId,
        'material'    : this.product.material ? this.product.material : '',
        'dimension'   : this.product.dimension ? this.product.dimension : '',
        'madeIn'      : this.product.madeIn ? this.product.madeIn : '',
        'companyId'   : this.company.Id
        }
        

        const sp        = {'sp' : 'spUpdateProduct'}
        const json      = Object.assign(item, sp);

        await api.post(json).then(res => {
          if(res.status==200)
            {
                this.$emit('update',this.product)              
            }
            else if(res.status==500)
            {
              

              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res.data
              this.msg.type  = 1    

            } 
            else
            {
              
              this.msg.title = "ATTENZIONE " 
              this.msg.body  = res
              this.msg.type  = 1    
               
            } 
        }).catch(err => 
        {
          
            this.msg.title = "ATTENZIONE " 
            this.msg.body  = err.message
            this.msg.type  = 1    
            
        }).finally(() => {
          this.bt_spinner = false
        });

      
    },  
  



    
    }
  
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btn_1
{
  font-family      : 'Roboto Condensed';
  background-color : khaki;
  color            : black
}
.btn_2
{
  font-family      : 'Roboto Condensed';
  background-color :  khaki;
  color            : black
}


label,i,span:hover {
   
   cursor    : pointer 
   
}
span{
  font-family: 'Roboto Condensed';
}

label{
  color:black
  
}
.bold {
font-weight: bolder;
}

/*input {border-color: coral;}*/

.form-text {
  color : red
}
/*
.is-flex {
  display: flex;
  flex-wrap: wrap;
}
*/

/*
.is-flex>[class*='col-'] {
  display: flex;
  flex-direction: column;
}
*/
/*
.action-panel {
  margin-bottom: 10px;
  margin-right: 5px;
}
*/

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.card-header{
  background-color:  rgb(209, 234, 206);  
  
}
</style>
